"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const LoadingIndicator_1 = __importDefault(require("./LoadingIndicator/LoadingIndicator"));
require("./LoadingSplashScreen.scss");
const LoadingSplashScreen = () => {
    return (react_1.default.createElement("div", { className: "center-loading-screen fade-in" },
        react_1.default.createElement(SVGIcon_1.default, { iconName: "icon-loading-page", size: 160 }),
        react_1.default.createElement(LoadingIndicator_1.default, { customClass: "mt-[24px]" })));
};
exports.default = LoadingSplashScreen;
